import { create } from 'zustand';

interface PopoverCloseSignalState {
    signal: number;
    trigger: () => void;
}

export const usePopoverCloseSignal = create<PopoverCloseSignalState>((set) => ({
    signal: 0,
    trigger: () => set((state) => ({ signal: state.signal + 1 })),
}));
